import { Component, OnInit,Input ,AfterViewInit} from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import{CommunicationRecordsPage} from '../communication-records/communication-records.page'
import{PotentialMembersdetailPage} from '../potential-membersdetail/potential-membersdetail.page'
import { HttpCustomerService, MessageclientService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { WebParameterContext } from 'src/model/common';
import { PotentialMemberslistPage } from '../potential-memberslist/potential-memberslist.page';
import { WxjssdkService }from "src/service/wxjssdk.service";
import { NativeService } from 'src/service/native.service';

declare var app;
@Component({
  selector: 'app-potential-members-detail',
  templateUrl: './potential-members-detail.component.html',
  styleUrls: ['./potential-members-detail.component.scss']
})
export class PotentialMembersDetailComponent {
  one:any = 1;
  tabinde:number= 1; //切换
  tabdetailShow:any; //切换显示
  PlaceName:any; // 修改的名字
  showName : any ="";
  pic:any="";//图像
  openid:any="";//Openid
  sureShow:boolean = false;
  WeiXinBrower:string="企业微信";//是否未企业微信文字
  @Input() type: any;
  dataArrayList1: Array<any> = [];//潜在会员
  dataArrayList2: Array<any> = [];//其他潜在会员
  dataArrayList3: Array<any> = [];//s1-2级会员
  communicationList: Array<any> = []; // 理货员沟通记录列表

  RecordCount1Number: number = 1;//潜在会员
  RecordCount2Number: number = 1;//产品购买详情
  RecordCount3Number: number = 1;
  _staticjson:any={};
  _isRead:boolean=false;
  currentId:string="";
  currentmemberId:string="";//会员ID
  labelList = [];//标签列表
  articleList = [];//内容库推荐
  userObj:any={};//用户信息
  staticUserObj:any={};//用户信息 
  shiyong:boolean=false;
  zore:boolean=false;
  zoreo:boolean=false;
  six:boolean=false;
  maxsix:boolean=false;
  tepeiCount:boolean = false; // 特配会员

  s1Count:number=0;//孕期
  S2Count:number=0;//0~6
  S3Count:number=0;//6~12
  S4Count:number=0;//12+
  S5Count:number= 0; // 特配会员
  userName:any="";
  lastBuyProduct:any={};//理货员任务内容 近期购买/试用
  CountNumber:any;
  pgId:any;
  HeadPicture:any; //图片
  isreplace:boolean=false;
  contentText:any; //  拿到的话术
  techniqueID:any; // 话术id
  recordWechatIDDetail:any=""; // 拿到的id
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
    public wx:WxjssdkService,
    private route: ActivatedRoute,
    private native: NativeService,
  ) {
    this.pgId = this.com.GetAccount.Id;
   }
   
   ngAfterViewInit(){
     const that=this;
    //  that.alreadyConnect()
  
    //  return;
    let _json = that.route.snapshot.queryParamMap["params"]||{};
    that._staticjson=_json;
    if(_json)
    {
      that.staticUserObj=_json; //readonly
      if( that.staticUserObj.tepeiCount >0 && that.staticUserObj.Stage<0){
        that.s1Count=that.staticUserObj.Stage;
        that.S2Count=1;
        that.tepeiCount=true;
        that.zore=true;
      }
      else if(that.staticUserObj.Stage<0){
        that.s1Count=that.staticUserObj.Stage;
        that.zore=true;
      }
      else if( that.staticUserObj.tepeiCount >0 && that.staticUserObj.Stage>=0 && that.staticUserObj.Stage<=6){
        that.S5Count=1;
        that.s1Count=1;
        that.S2Count=1;
        that.zoreo=true;
        // that.tepeiCount=true;
        
      }
      else if( that.staticUserObj.tepeiCount >0 && that.staticUserObj.Stage<=12 && that.staticUserObj.Stage>6){
        that.s1Count=1;
        that.S2Count=1;
        that.S3Count=1;
        that.S5Count=1;
        that.six=true;
      }
      else if( that.staticUserObj.tepeiCount >0 && that.staticUserObj.Stage>12){
        that.s1Count=1;
        that.S2Count=1;
        that.S3Count=1;
        that.S4Count=1;
        that.S5Count=1;
        that.maxsix=true;
      }
      else if(that.staticUserObj.tepeiCount >0){
        that.S5Count=1;
        that.tepeiCount=true;
      }
      //end
      else if(that.staticUserObj.Stage>=0 && that.staticUserObj.Stage<=6){
        that.s1Count=1;
        that.S2Count=1;
        that.S5Count=1;
        that.zoreo=true;
      }
     
      else if(that.staticUserObj.Stage<=12 && that.staticUserObj.Stage>6){
        that.s1Count=1;
        that.S2Count=1;
        that.S3Count=1;
        that.S5Count=1;
        that.six=true;
      }else if(that.staticUserObj.Stage>12){
        that.s1Count=1;
        that.S2Count=1;
        that.S3Count=1;
        that.S4Count=1;
        that.S5Count=1;
        that.maxsix=true;
   }
      that.userObj["TA_Name"]=_json["TA_Name"]||"";
      if(_json["CRM_Name"])
      {
        that.userName=_json["CRM_Name"]||"";
        that.showName=_json["CRM_Name"]||"";
        // that.userObj["TA_Name"]=_json["CRM_Name"]||"";
      }else{
        that.userName=_json["TA_Name"]||"";
        that.showName=_json["TA_Name"]||"";
        // that.userObj["TA_Name"]=_json["TA_Name"]||"";
      }
        // that.PlaceName = that.userObj["TA_Name"];
       if(_json["JoinDate"])
      {
        that.userObj.JoinDate=_json.JoinDate.replace(/-/g,"/").replace("T","");
      }
      // debugger;
      if(_json["IsAuth"]=="true"){
        that.isreplace=true;
        that.isreplace = !that.isreplace;
      }else if(_json["IsAuth"]=="false"){
        that.isreplace=false;
        that.isreplace = !that.isreplace;
      }
      // console.log(that.isreplace,"uuuuuuuuuuuuuuuuuuuuuuu")
      if(_json["TA_Mobile"])
      {
       
        this.userObj["TA_Mobile"]=this.com.PhoneNum(_json["TA_Mobile"],that.isreplace);
      }
      if(_json["HeadPicture"]){
        that.HeadPicture= _json["HeadPicture"];
      }

      // if(_json["WeChatNickName"])
      // {
      //   this.userObj["WeChatNickName"]=_json["WeChatNickName"]||"";
      // }


      //   微信昵称取值
      if(_json["WeChatNickName"]){
        this.userObj["WeChatNickName"] = _json["WeChatNickName"]||"";
      }else if(_json["TA_Name"]){
        this.userObj["WeChatNickName"] = _json["TA_Name"]||"";
      }else if(_json["Name"]){
        this.userObj["WeChatNickName"] = _json["Name"]||"";
      }
      
      if(_json["HeadPicture"]){
        this.pic=_json["HeadPicture"]||"";
      }
      if(_json["openid"]){
        this.openid=_json["openid"]||"";
      }
      if(_json["Current_Stage_Title"])
      {
        this.userObj["Current_Stage_Title"]=_json["Current_Stage_Title"]+ _json["Offset_Day"] +"天";
        if(_json["Current_Stage_Title"]=="Baby_24+")
        {
          this.userObj["Current_Stage_Title"]=_json["Current_Stage_Title"];
        }
        else if(_json["Current_Stage_Title"]=="Stage_Others")
        {
          this.userObj["Current_Stage_Title"]=_json["Current_Stage_Title"];
        }
      }
      if(_json["Count"]){
        that.CountNumber=_json["Count"];
      }
      //  拿到的记录id
      if(_json["recordWechatID"]){
        that.recordWechatIDDetail = _json["recordWechatID"]
      }
      console.log(_json,"当前user");
      this.currentId=this._staticjson["ID"];
      this.currentmemberId = this._staticjson["FK_MembersInfoManagement_ID"];//会员ID
    }
    that.LoadDataProductDetail();
    that.LoadlabelData();
    // 显示复制消息
    that.copythewordsart();
   
   }
    /**
   * 
   * @param 拿到对应的复制话术
   */
  copythewordsart(){
    const that =this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "GetMotAutoReplayInfo";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 15;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "product";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    typeObj["motid"] =  that.currentId;
    // typeObj["motid"] = "91FFCD56-D91C-4977-BC2A-91C73E49B90A";
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        console.log(data.Status.Datas)
        console.log(data.Status.Datas.length)
        if(data.Status.Datas.length>0){
          let cont= data.Status.Datas[0];
          that.techniqueID = cont.ID;
          console.log(cont.Content.indexOf("{0}"))
          if(cont.Content.indexOf("{0}")>-1){
            // that.contentText = cont.Content.replace("{0}"+cont.Remark;
            that.contentText = cont.Content.replace("{0}",cont.Remark);
            if(that.contentText){
              that.alreadyConnectwordsart();
            }
          }else{
            that.contentText = cont.Content;
            if(that.contentText){
              that.alreadyConnectwordsart();
            }
          }   
        }
       
        
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {

      that.msg.Alert(error.ResponseMessage.ErrorMessage);
      // console.log(error);
    });

    }
   

/**
 * 记录发微信的接口
 */
 recordWechat(){
  const that =this;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "TBSendMessageRecordXML";
  body.OpType = "edite";
  body.ConfigType = "form";
  body.RowsPerPage = 15;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = "product";
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  let typeObj = {};
  typeObj["a_ID"] =  that.recordWechatIDDetail;
  typeObj["a_SendStatus"] =  "2";
  typeObj["a_FK_TBPosterContent_ID"] = that.techniqueID;
  // typeObj["motid"] = "91FFCD56-D91C-4977-BC2A-91C73E49B90A";
  body.RequestBody = JSON.stringify(typeObj);
 that.msg.Loading("加载中，请稍后...").then(load=>{
  that.http.post(app.DEFAULTURL, body).then(data => {
    load.dismiss();
    if (data.ResponseMessage.Success) {
      
      
    }else{
      that.msg.Alert(data.ResponseMessage.ErrorMessage);
    }

  }).catch(error => {
    load.dismiss();
    that.msg.Alert(error.ResponseMessage.ErrorMessage);
    // console.log(error);
  });
   load.present();
 })
 }
/**
 * 发微信
 */
   weixinCactInfo(){
     const that=this;
    if(that.com.IsWeixinBrowser){//如果是微信浏览器
      if(that.openid){//如果微信ID存在
          that.wx.CreateopenEnterpriseChat("",that.openid,"").then(res=>{
            // that.msg.Alert(JSON.stringify(res));
            that.WeiXinBrower="与【"+that.userName+"】聊天"; 
            try{
              that.WeiXinClick();
              that.recordWechat();
             }catch(err){
     
             }
            
          }).catch(res=>{
            that.msg.Alert(res.ResponseMessage.ErrorMessage).then(data=>{
              if(res.ResponseMessage.ErrorCode==404){
                  //如果没有微信userID
                  that.wx.selectExternalContact(0).then(res=>{
                    if(res.ResponseMessage.Success){
                      let userinfo:string =res.Status[0].toString();
                      that.openid=userinfo;
                      try{
                        that.UpdateWebCatUserID(that.openid,that.currentmemberId);
                       }catch(err){
               
                       }
                      console.log(userinfo,"用户userID");
                      that.wx.CreateopenEnterpriseChat("",userinfo,"").then(res=>{
                        that.WeiXinBrower="与【"+that.userName+"】聊天"; 
                        try{
                          that.WeiXinClick();
                          that.recordWechat();
                         }catch(err){
                 
                         }
                        
                      }).catch(res=>{
                     
                      if(app.DEBUG){
                            that.msg.Alert(res.ResponseMessage.ErrorMessage);
                          }
                          that.WeiXinBrower=res.ResponseMessage.ErrorMessage; 
                          try{
                            that.WeiXinClick();
                           }catch(err){
                   
                           }
                          
                      });
                    };
                  }).catch(err=>{
                  
                    if(app.DEBUG){
                    that.msg.Alert(err.ResponseMessage.ErrorMessage);
                    }
                    that.WeiXinBrower=err.ResponseMessage.ErrorMessage; 
                    that.WeiXinClick();
                  
                  });
              }else{
                that.wx.OpenUserProfile(2,that.openid).then(res=>{
                  that.WeiXinBrower="与【"+that.userName+"】聊天"; 
                  try{
                    that.WeiXinClick();
                    that.recordWechat();
                   }catch(err){
           
                   }
                }).catch(res=>{
                 
                  // if(app.DEBUG){
                  //   that.msg.Alert(res.ResponseMessage.ErrorMessage);
                  // }
                that.msg.Alert(res.ResponseMessage.ErrorMessage);
                that.WeiXinBrower=res.ResponseMessage.ErrorMessage; 
                that.WeiXinClick();
                });
              }
            });
          });
      }else{
          //如果没有微信userID
          that.wx.selectExternalContact(0).then(res=>{
            if(res.ResponseMessage.Success){
              let userinfo:string =res.Status[0].toString();
              that.openid=userinfo;
              try{
              that.UpdateWebCatUserID(that.openid,that.currentmemberId);
              }catch(err){

              }
              that.wx.CreateopenEnterpriseChat("",userinfo,"").then(res=>{
              //  that.msg.Alert(JSON.stringify(res));
              that.WeiXinBrower="与【"+that.userName+"】聊天"; 
              try{
                that.WeiXinClick();
                that.recordWechat();
               }catch(err){
       
               }
              }).catch(res=>{
               
              if(app.DEBUG){
                    that.msg.Alert(res.ResponseMessage.ErrorMessage);
                  }
                  that.WeiXinBrower=res.ResponseMessage.ErrorMessage; 
                  try{
                    that.WeiXinClick();
                    that.recordWechat();
                   }catch(err){
           
                   }
              });
            };
          }).catch(err=>{
            if(app.DEBUG){
            that.msg.Alert(err.ResponseMessage.ErrorMessage);
            }
            that.WeiXinBrower=err.ResponseMessage.ErrorMessage; 
            that.WeiXinClick();
          
          });
        }
      }else{
        //不是微信浏览器打开
       that.WeiXinBrower="非企业微信打开"; 
        that.WeiXinClick();
      }
   }
   /**
   * 打电话
   * @param event 电话号码
   */
  EventCall(event) {
    console.log(event,"电话");
    this.native.GetCallPhone(event).then(fail => {
      console.log(fail);
    }).catch(error => {
      console.log(error);
    })
  }
  // 切换显示
  tabEven(num){
    const that = this;
    that.tabinde = num;
    if(num==2){
    // this.LoadDataProductDetail();//产品记录详情
    }else if(num == 3 || num == "3"){
     that.communication();
    }else if(num == 1){
      that.LoadlabelData();
    }
    // that.currentId="F14EF909-9120-4D97-B6CD-B6197EE467B8";
  }
  // 点击修改名字弹窗
  modificationname(){
    const that = this;
    that.sureShow= true;
  }
  /**
   * // 修改名字确定按钮
   */
  sureModal(){
    const that = this;
    
    if(!that.showName){
      that.sureShow= true;
      that.msg.Alert("姓名不能为空");
      return;
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "Update_Memer_NickNameBySNC";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
   
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
    typeObj["ID"] = that.currentId;
    typeObj["CRM_Name"] =   that.showName;
    body.RequestBody = JSON.stringify(typeObj);
   that.msg.Loading("加载中，请稍后...").then(load=>{
    that.http.post(app.DEFAULTURL, body).then(data => {

      that.sureShow= false;
      load.dismiss();
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.userName=that.showName;
        that.userObj["CRM_Name"]=that.userName;
      // //  that.msg.Alert("操作成功");
      //   console.log(that.dataArrayList2, "操作成功");
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      load.dismiss();
      that.msg.Alert("修改姓名失败");
      // console.log(error);
    });
     load.present();
   })
  }
  /**
   * 更新外部联系人的userID
   * @param userid 当前选择的人的userID
   * @param id 当前数据的id
   */
 UpdateWebCatUserID(userid:string,id:any){
   const that=this;
   const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
   let body = new WebParameterContext();
   body.Account = that.com.GetAccount;
   body.ConfigName = "MembersInfoManagementXML";
   body.OpType = "edite";
   body.ConfigType = "form";
   body.RowsPerPage = 1000;
   body.PageNumber = 1;
   body.Client.PageName = PageName;
   body.Client.ApiType = "Element";
   body.Client.Name = "";
   body.Client.ClientType = 2;
   let typeObj = {};
        typeObj["a_WeChat_ID"] =userid;
        typeObj["a_ID"] =id;
   body.RequestBody = JSON.stringify(typeObj);
   that.http.post(app.DEFAULTURL, body).then(data => {
    console.log(data,"更新状态");
   }).catch(error => {
    console.log(error,"更新状态失败");
     // console.log(error);
   });
 }
  // 修改名字取消按钮
  dissModal(){
    const that = this;
    that.sureShow= false;
  }
  /**
   * // 添加沟通记录
   */
async memberRexords(){
  console.log("点击弹窗")
    const that = this;
    const modal = await that.modal.create({
      component: CommunicationRecordsPage,
      componentProps: {
        "name": this.userObj["WeChatNickName"],
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data, "onWillDismiss");
    if(data&&data["modalStatus"])
    {
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
  
      body.ConfigName = "CommunicationRecordXML";
      body.OpType = "add";
      body.ConfigType = "form";
      body.RowsPerPage = 1000;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = "";
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      let typeObj = {};
      typeObj["a_FK_TBStore_ID"] =that.com.GetStorageKey("tbstore")["ID"]||"";
      typeObj["a_FK_SystemUser_ID"] =that.com.GetAccount.Id;
      typeObj["a_FK_MembersInfoManagement_ID"] =that.currentId;
        typeObj["a_CommunicationContent"] = data["Result"]||"";
      body.RequestBody = JSON.stringify(typeObj);
      that.http.post(app.DEFAULTURL, body).then(data => {
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          if(that.tabinde==3){
            that.communication();
          }
        }
      }).catch(error => {
        that.msg.Alert(app.ErrorMessage);
        // console.log(error);
      });
    }
  }
  
  /**
   * // 添加标签
   */
  async addType(){
    console.log("点击弹窗")
      const that = this;
      const modal = await that.modal.create({
        component: PotentialMembersdetailPage,
        componentProps: {
          "info":{
            id:that.currentId,
            mobile:that._staticjson["TA_Mobile"],
          },
          StageTitle:that.userObj["Current_Stage_Title"],
          Stage:that.staticUserObj.Stage
        }
      });
      await modal.present();
      // return await modal.present();
      const { data } = await modal.onWillDismiss();
      console.log(data, "onWillDismiss");
      if(data["modalStatus"]){
        that.LoadlabelData();
      }
    }
    /**
     * 聊天记录
     */
WeiXinClick()
  {
    let that=this;
    //记录微信点击次数
   const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
   let body = new WebParameterContext();
   body.Account = that.com.GetAccount;
   body.ConfigName = "TBMembershipFootprintsClickRecordXML";
   body.OpType = "add";
   body.ConfigType = "form";
   body.RowsPerPage = app.RowsPerPage;
   body.PageNumber = 0;
   body.Client.PageName = PageName;
   body.Client.ApiType = "Element";
   body.Client.Name = "";
   body.Client.ClientType = 2;
   if (that.platform.is("android")) {
     body.Client.ClientType = 0;
   } else if (that.platform.is("ios")) {
     body.Client.ClientType = 1;
   }
   let reqParma={};
   reqParma["a_PageName"]="会员关怀提醒";
   reqParma["a_ButtonName"]="微信";
   reqParma["a_ButtonDisplayName"]=that.WeiXinBrower;
   reqParma["a_FK_MembersInfoManagement_ID"]=that.currentmemberId;
   const tbstoreStr=localStorage.getItem("tbstore");
   let storeId;
   if(tbstoreStr)
   {
      storeId=JSON.parse(tbstoreStr);
   }
   reqParma["a_FK_TBStore_ID"]=storeId.ID||"";
   body.RequestBody=JSON.stringify(reqParma);
   that.http.post(app.DEFAULTURL, body).then(data => {
     /****判断是否第一页end****/
     if (data.ResponseMessage.Success) {
       console.log(data,"添加微信次数成功");
     } else {
       that.msg.Alert(data.ResponseMessage.ErrorMessage);
     }
   }).catch(error => {
     console.log(error);
     that.msg.Alert(error.ResponseMessage.ErrorMessage);
   });
  }
    /**
     * 产品购买详情
     */
    LoadDataProductDetail() {
      var that = this;
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
  
      body.ConfigName = "HistoricalPurchase";
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = 1000;
     
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = "";
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      let typeObj = {};
      //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
      typeObj["Mobile"] = that._staticjson["TA_Mobile"]||"";
      body.RequestBody = JSON.stringify(typeObj);
      that.http.post(app.DEFAULTURL, body).then(data => {
  
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          that.lastBuyProduct = data.Status.Data;
          that.lastBuyProduct.forEach(item => {
            // console.log(item.BuyTime)
            if(item["BuyTime"])
            {
              item["BuyTime"]=item["BuyTime"].replace(/-/g,"/").replace("T"," ");
              // item["BuyTime"]="2021/09/09 14:14:38.568";
              let href = item["BuyTime"];
              var indexOf = href.indexOf('.');
              let len = href.substring(indexOf,href.length);
              var newHref = href.replace(len,'');
              item["BuyTime"]=newHref;
              
              console.log( item["BuyTime"])
            }
          });
          if(that.lastBuyProduct.length>0)
          {
            let _length=that.lastBuyProduct.length-1;
            let _buyDay=0;
            if(that.lastBuyProduct[_length]&&that.lastBuyProduct[_length]["BuyTime"])
            {
              // let buyTime= new Date(that.lastBuyProduct[_length]["BuyTime"]).getTime();
  
              // var  startDate = new Date(that.lastBuyProduct[_length]["BuyTime"]);
              // var  endDate = new Date();
              // // console.log(localDate)
              // console.log(startDate,"startDate");

              // console.log(endDate,"endDate");
              // console.log(endDate.getTime(),"endDategetTime");
              // console.log(startDate.getTime(),"tartDategetTime");
              // let days=(endDate.getTime() - startDate.getTime())/(1*24*60*60*1000);
              let buyTime= new Date(that.lastBuyProduct[_length]["BuyTime"]);
              let localDate=new Date().toString();
              var  startDate = Date.parse(that.lastBuyProduct[_length]["BuyTime"]);
              var  endDate = Date.parse(localDate);
              var days=(endDate - startDate)/(1*24*60*60*1000);

              // let days=(endDate - startDate);
              // yyyymmddhhmmss
                console.log(localDate)
              console.log(startDate,"startDate");
              console.log(days);
              console.log(that.lastBuyProduct[_length]["BuyTime"])
              let par=parseInt(days.toString());
              let useProductName=that.lastBuyProduct[_length]["ProductShortName"];
              if(!useProductName){
                   useProductName=that.lastBuyProduct[_length]["ProductName"];
              }
              if(par>30)
              {
                if(useProductName){
                  that.userObj["ProductShortName"]=that.lastBuyProduct[_length]["BuyTime"].replace(/\-/g, "/").replace("T"," ")+"购买 "+ useProductName;
                }else{
                  that.userObj["ProductShortName"]=that.lastBuyProduct[_length]["BuyTime"].replace(/\-/g, "/").replace("T"," ")+"未购买";
                }
                console.log(that.userObj["ProductShortName"])
              }else{
                console.log(par,"多少天购买")
                that.userObj["ProductShortName"]=par.toString()+"天前购买"+ useProductName;
              }
            
            }
            
          }
          console.log(that.lastBuyProduct, "dataArrayList");
        }
  
      }).catch(error => {
        
        // console.log(error);
      });
    }
        //标记已沟通  弹窗
        async alreadyConnect(){
          console.log("点击弹窗")
            const that = this;
            const modal = await that.modal.create({
              component: PotentialMemberslistPage,
              componentProps: {
                 typeName: "alreadyCon",
                 typeTitle:"标记沟通"
              }
            });
          //   const modal = await this.modalController.create({
          //     component: IceboxSearchComponent,
          //     componentProps: { configNameParamType: type }
          // });
            await modal.present();
            // return await modal.present();
            const { data } = await modal.onWillDismiss();
            console.log(data, "onWillDismiss");
            if(data.typeTitle=='标记沟通'){
              if(data&&data.modalStatus)
              {
                const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
                let body = new WebParameterContext();
                body.Account = that.com.GetAccount;
            
                body.ConfigName = "Update_MOT_StatusBySNC";
                body.OpType = "edite";
                body.ConfigType = "form";
                body.RowsPerPage = app.RowsPerPage;
               
                body.PageNumber = 1;
                body.Client.PageName = PageName;
                body.Client.ApiType = "Element";
                body.Client.Name = "";
                body.Client.ClientType = 2;
                if (that.platform.is("android")) {
                  body.Client.ClientType = 0;
                } else if (that.platform.is("ios")) {
                  body.Client.ClientType = 1;
                }
                let typeObj = {};
                //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
                typeObj["ID"] =that.currentId;
                typeObj["Status"] = data.type||0;
                body.RequestBody = JSON.stringify(typeObj);
                that.http.post(app.DEFAULTURL, body).then(data => {
            
                  /****判断是否第一页end****/
                  if (data.ResponseMessage.Success) {
                   that.msg.Alert("操作成功");
                    console.log(that.dataArrayList2, "操作成功");
                  }
            
                }).catch(error => {
                 
                  // console.log(error);
                });
              }
            }
            return;
           
          }
          async alreadyConnectwordsart(){
            console.log("点击弹窗")
            const that = this;
            const modal = await that.modal.create({
              component: PotentialMemberslistPage,
              componentProps: {
                 typeName: "alreadyCon",
                 typeTitle:"发微信",
                 contentText:that.contentText,
                 techniqueID:that.techniqueID,
                 currentId:that.recordWechatIDDetail

              }
            });
          //   const modal = await this.modalController.create({
          //     component: IceboxSearchComponent,
          //     componentProps: { configNameParamType: type }
          // });
            await modal.present();
            // return await modal.present();
            const { data } = await modal.onWillDismiss();
            console.log(data, "onWillDismiss");
            if(data.typeTitle=='发微信'){
             
            }
            
              // return await modal.present();
              return;
             
            }
          // 理货员沟通接口
          communication(){
            var that = this;
            const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
            let body = new WebParameterContext();
            body.Account = that.com.GetAccount;
        
            body.ConfigName = "CommunicationRecordXML";
            body.OpType = "query";
            body.ConfigType = "view";
            body.RowsPerPage = 10;
            body.PageNumber = 1;
            body.Client.PageName = PageName;
            body.Client.ApiType = "Element";
            // body.Client.Name = "";
            body.Client.ClientType = 0;
            let typeObj = {};
            typeObj["a_FK_SystemUser_ID"] =that.com.GetAccount.Id;
            typeObj["a_FK_MembersInfoManagement_ID"] =that.currentId;
            body.RequestBody = JSON.stringify(typeObj);
            that.http.post(app.DEFAULTURL, body).then(data => {
        
              /****判断是否第一页end****/
              if (data.ResponseMessage.Success) {
                that.communicationList = data.Status.Datas;
                console.log(that.communicationList, "理货员沟通记录列表");
                that.communicationList.forEach(item=>{
                  if(item.a_CreateTime){
                    item.a_CreateTime= item.a_CreateTime.replace(/-/g,"/").replace("T","");
                  }
                });
              }else{
                that.msg.Alert(data.ResponseMessage.ErrorMessage);
              }
        
            }).catch(error => {
              // that.apiObj['status'] = false;
              // that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
             
              // console.log(error);
            });
          }

    /**
     * 获取会员标签信息
     */
    LoadlabelData(){
      var that = this;
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
  
      body.ConfigName = "GetLableGroupCount";
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = 1000;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      body.RequestBody = JSON.stringify({
        FK_MembersInfoManagement_ID:that.currentId
      })
      that.http.post(app.DEFAULTURL, body).then(data => {
        
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          that.labelList = [];
          data.Status.forEach(item=>{
            let isPush = false;
            that.labelList.forEach(l=>{
              if(item["Name"] == l["Name"]){
                  isPush = true;
              }
            })
            if(!isPush){
              that.labelList.push(item);
            }
          });
          that.articleList = [];
          that.labelList.forEach(item=>{
            if(item["Count"] > 0){
              that.articleList.push(item);
            }
          })
          that.labelList=that.labelList.slice(0,2);
          console.log(data,"----------------------------------------------");
        }else{
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
  
      })
    }

    /**
     * 查看内容库详情
     * @param item 
     */
    showArticleInfo(item,type){
      console.log(item,"showArticleInfo查看内容库详情");
      this.com.setHistoryUrl(false);
      if(type == 2){
        this.com.Go("/tabs/contact/ContentLibraryHome/" + this.com.getNowDatetime);
      }else{
        this.com.Go("/tabs/contact/ContentLibraryList/" + this.com.getNowDatetime,{
          a_ID:item.FK_TBHighFrequencyTag_ID,
          type:1 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
        });
      }
    }
    // 跳标准话术
    showDescribed(){
       this.com.setHistoryUrl(false);
       this.com.Go("/tabs/technique-described/" + this.com.getNowDatetime);
    }
} 
